interface FormData {
  ad: string;
  tip: string;
  aciklama: string;
  baslamaTarihi: string;
  bitisTarihi: string;
  dahiliNot: string;
}

interface Step1Props {
  data: FormData;
  onChange: (data: Partial<FormData>) => void;
}

const KAMPANYA_TIPLERI = [
  "Referans İsteme",
  "Referans Vermeyen Veliye Mesaj",
  "Ödeme Hatırlatma",
  "Taahhüt Bitiş Bilgilendirme",
  "Kampanya Duyurusu",
  "Sistem Güncelleme",
  "Yeni Kayıt Hoş Geldin",
  "Deneme Ders Sonrası Takip",
];

export default function Step1Bilgiler({ data, onChange }: Step1Props) {
  return (
    <div className="space-y-5">
      <div>
        <h3 className="text-base font-bold text-gray-900 mb-1">Kampanya Bilgileri</h3>
        <p className="text-sm text-gray-500">Kampanyanızın temel bilgilerini girin.</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div className="sm:col-span-2">
          <label className="block text-xs font-semibold text-gray-600 mb-1.5">Kampanya Adı *</label>
          <input
            type="text"
            value={data.ad}
            onChange={(e) => onChange({ ad: e.target.value })}
            placeholder="örn. Haziran Referans Kampanyası"
            className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#25D366]/30 focus:border-[#25D366] bg-white"
          />
        </div>

        <div>
          <label className="block text-xs font-semibold text-gray-600 mb-1.5">Kampanya Türü *</label>
          <div className="relative">
            <select
              value={data.tip}
              onChange={(e) => onChange({ tip: e.target.value })}
              className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#25D366]/30 focus:border-[#25D366] bg-white appearance-none cursor-pointer"
            >
              <option value="">Tür seçin...</option>
              {KAMPANYA_TIPLERI.map((t) => (
                <option key={t} value={t}>{t}</option>
              ))}
            </select>
            <div className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center text-gray-400 pointer-events-none">
              <i className="ri-arrow-down-s-line text-base"></i>
            </div>
          </div>
        </div>

        <div>
          <label className="block text-xs font-semibold text-gray-600 mb-1.5">Başlangıç Tarihi</label>
          <input
            type="date"
            value={data.baslamaTarihi}
            onChange={(e) => onChange({ baslamaTarihi: e.target.value })}
            className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#25D366]/30 focus:border-[#25D366] bg-white cursor-pointer"
          />
        </div>

        <div>
          <label className="block text-xs font-semibold text-gray-600 mb-1.5">Bitiş Tarihi</label>
          <input
            type="date"
            value={data.bitisTarihi}
            onChange={(e) => onChange({ bitisTarihi: e.target.value })}
            className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#25D366]/30 focus:border-[#25D366] bg-white cursor-pointer"
          />
        </div>

        <div className="sm:col-span-2">
          <label className="block text-xs font-semibold text-gray-600 mb-1.5">Açıklama</label>
          <textarea
            value={data.aciklama}
            onChange={(e) => onChange({ aciklama: e.target.value })}
            placeholder="Kampanya hakkında kısa açıklama..."
            className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#25D366]/30 focus:border-[#25D366] bg-white resize-none h-24"
            maxLength={500}
          />
        </div>

        <div className="sm:col-span-2">
          <label className="block text-xs font-semibold text-gray-600 mb-1.5">Dahili Not</label>
          <textarea
            value={data.dahiliNot}
            onChange={(e) => onChange({ dahiliNot: e.target.value })}
            placeholder="Bu kampanya hakkında dahili notlarınız (velilere gösterilmez)..."
            className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#25D366]/30 focus:border-[#25D366] bg-white resize-none h-20"
            maxLength={500}
          />
        </div>
      </div>
    </div>
  );
}